// extracted by css-extract-rspack-plugin
export default {"link":"IssueFieldValueBadge-module__link__Jqf2s","token":"IssueFieldValueBadge-module__token__FssCq"};